export const schemeFormTranslations = {
    en: {
        // Field Labels
        schemeName: "Scheme Name",
        description: "Description",
        requiredDocuments: "Required Documents",
        diseasesProcedures: "Diseases / Procedures",
        eligibility: "Eligibility",

        // Validation Messages
        nameRequired: "Please enter scheme name",
        descriptionRequired: "Please enter description",
        documentRequired: "Please select at least one document",
        diseaseRequired: "Please select at least one disease",
        eligibilityRequired: "Please enter eligibility criteria",

        // Placeholders
        documentPlaceholder: "Type and press enter to add documents",
        diseasesProceduresPlaceholder: "Select Diseases / Procedures",

        // Document Options
        aadharCard: "Aadhar Card",
        incomeCertificate: "Income Certificate",
        rationCard: "Ration Card",
        panCard: "PAN Card",
        voterId: "Voter ID",

        // Button
        submit: "Submit"
    },
    mr: {
        // Field Labels
        schemeName: "योजनेचे नाव",
        description: "वर्णन",
        requiredDocuments: "आवश्यक कागदपत्रे",
        diseasesProcedures: "रोग / प्रक्रिया",
        eligibility: "पात्रता",

        // Validation Messages
        nameRequired: "कृपया योजनेचे नाव प्रविष्ट करा",
        descriptionRequired: "कृपया वर्णन प्रविष्ट करा",
        documentRequired: "कृपया किमान एक दस्तऐवज निवडा",
        diseaseRequired: "कृपया किमान एक रोग निवडा",
        eligibilityRequired: "कृपया पात्रता निकष प्रविष्ट करा",

        // Placeholders
        documentPlaceholder: "टाइप करा आणि कागदपत्रे जोडण्यासाठी एंटर दाबा",
        diseasesProceduresPlaceholder: "रोग / प्रक्रिया निवडा",

        // Document Options
        aadharCard: "आधार कार्ड",
        incomeCertificate: "उत्पन्न प्रमाणपत्र",
        rationCard: "शिधापत्रिका",
        panCard: "पॅन कार्ड",
        voterId: "मतदार ओळखपत्र",

        // Button
        submit: "सबमिट करा"
    }
};
